import axios from '@/axios.js'

export default {
  updateUser({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .patch('/tenant-users/' + item.id, item)
        .then((response) => {
          commit('UPDATE_USER', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addUser({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post('/tenant-users', item)
        .then((response) => {
          commit('UPDATE_USER', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchUsers({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/tenant-users?join=userRoles&join=userRoles.role', {
          params: payload,
        })
        .then((response) => {
          commit('SET_USERS', response.data)
          commit('SET_PAGINATION', {
            currentPage: parseInt(response.headers['x-pagination-page']),
            totalPage: parseInt(response.headers['x-pagination-page-count']),
            pageTotal: parseInt(response.headers['x-pagination-count']),
            totalItem: parseInt(response.headers['x-pagination-total']),
          })

          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  deleteUser(context, user) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/tenant-users/${user.id}`, {
          name: user.name,
          emailAddress: user.emailAddress,
          generalStatus: 'DISABLED',
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchUser(context, userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/tenant-users/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
